import type { PaginationToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const usePaginationTokens = (theme: Theme): PaginationToken => {
  const { component } = theme;
  const base = {};

  return merge({}, base, component?.pagination) as PaginationToken;
};
